import React from "react";

const Image = ({ src, alt, style, className }) => (
  <img src={src} alt={alt} style={style} className={className} />
);

export default Image;
